<template>
    <aside :class="enabled ? 'ath-toggle-modal pf' : ''">
        <div v-if="enabled" class="ath-toggle-modal-bg pa-f c-el-overlay-dark-bg"></div>
        <div :class="enabled ? 'ath-toggle-modal-container f fa-c fj-c pa-f' : ''">
            <slot name="content"></slot>
        </div>
    </aside>
</template>

<script>
export default {
    name: 'mead-standalone-toggle-modal',
    props: {
        /**
         * Whether the modal (and its dark overlay background) is shown. When false, nothing is
         * rendered in place of it.
         */
        enabled: {type: Boolean, default: false},
    },
};
</script>
<style lang="scss" scoped>
@import '../../../../sass/variables';
.ath-toggle-modal {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: $zx-modal;

    .ath-toggle-modal-bg {
        z-index: calc(#{$zx-page-overlay} - 1);
        opacity: .8;
        animation: overlayBgIn .2s forwards ease-out;
    }

    .ath-toggle-modal-container {
        z-index: $zx-page-overlay;
        transition-property: top, left, right, bottom;
        transition-duration: 2s;
        transition-delay: 0;

        @media (prefers-reduced-motion: reduce) {
            transition: none;
        }
    }
}
</style>
